import axios from 'src/shared/utils/axios';
import { type CategoriesLimits } from './types';

const flexflowEndpoint = `${process.env.REACT_APP_API_URL}flexflow`;
const employeeMonthlyLimitsEndpoint = (employeeId: number) => `${flexflowEndpoint}/employees/${employeeId}`;

const putCategoryLimits = async (employeeId: number, limits: CategoriesLimits): Promise<{ data: CategoriesLimits }> => {
  const payload = {
    foodLimit: Number(limits.foodLimit),
    transportLimit: Number(limits.transportLimit)
  };
  const res = await axios.put(employeeMonthlyLimitsEndpoint(employeeId), payload);
  return { data: res.data };
};

export const flexflowApi = {
  putCategoryLimits
};
